module.exports = __webpack_public_path__ + "img/logo-kamitech.96ad61dc.svg";